import { jsx as g } from "react/jsx-runtime";
import { memo as y, useMemo as p, useCallback as C } from "react";
import { useTranslation as H } from "react-i18next";
import { LoadingEnum as v } from "@perxis-auto/shared";
import { useField as M } from "@perxis-auto/trade-in-sdk";
import { RuleId as i, WidgetType as l, ErrorStatusCode as F } from "@perxis-auto/trade-in-sdk/types";
import { Form as x } from "@perxis-auto/ui-kit/lib/components/Form";
import { APP as k } from "../../../shared/config/app.js";
import { APP_EVENTS as G } from "../../../shared/config/events.js";
import { eventService as U } from "../../../shared/lib/event/eventService.js";
import { FIELD_ELEMENT_VALUE as f } from "./Field.types.js";
import { FieldElement as q } from "./FieldElement.js";
const $ = y(function({ fieldId: m, formId: T }) {
  const { t: u } = H(k.name), {
    data: r,
    options: d = [],
    loading: b,
    disabled: h,
    error: E
  } = M({ id: m, formId: T }), _ = [v.Idle, v.Pending].includes(b), A = p(() => {
    var a;
    if (!r)
      return;
    const t = [];
    return r.required && t.push({
      required: !0,
      message: u("field.errors.required")
    }), (a = r.rules) == null || a.forEach((e) => {
      if (!e.id || typeof e.value > "u")
        return;
      const o = e.error_message ?? u("field.errors.incorrect");
      switch (e.id) {
        case i.MIN_LENGTH: {
          typeof e.value == "number" && t.push({
            min: e.value,
            message: o
          });
          break;
        }
        case i.MAX_LENGTH: {
          typeof e.value == "number" && t.push({
            max: e.value,
            message: o
          });
          break;
        }
        case i.GREATER_THAN:
        case i.GREATER_THAN_OR_EQUAL: {
          if (typeof e.value == "number") {
            const s = e.value;
            t.push(() => ({
              validator(c, n) {
                return typeof n > "u" || (e.id === i.GREATER_THAN_OR_EQUAL ? n >= s : n > s) ? Promise.resolve() : Promise.reject(new Error(o));
              }
            }));
          }
          break;
        }
        case i.LESS_THAN:
        case i.LESS_THAN_OR_EQUAL: {
          if (typeof e.value == "number") {
            const s = e.value;
            t.push(() => ({
              validator(c, n) {
                return typeof n > "u" || (e.id === i.LESS_THAN_OR_EQUAL ? n <= s : n < s) ? Promise.resolve() : Promise.reject(new Error(o));
              }
            }));
          }
          break;
        }
        case i.PATTERN: {
          t.push({
            pattern: e.value,
            message: o
          });
          break;
        }
      }
    }), t;
  }, [r, u]), L = p(() => {
    if (!(!d || !d.length || !(r != null && r.widget)))
      switch (r.widget) {
        case l.SELECT:
        case l.AUTOCOMPLETE: {
          if (!r.group_by)
            return d.map((e) => ({
              label: e.text,
              value: e.id,
              [f]: e
            }));
          const t = (e, o) => o.split(".").reduce((s, c) => s && s[c], e), a = /* @__PURE__ */ new Map();
          return d.forEach((e) => {
            const o = t(e, r.group_by), s = a.get(o) || [];
            return a.set(o, [
              ...s,
              {
                label: e.text,
                value: e.id,
                [f]: e
              }
            ]);
          }), [...a].map(([e, o]) => ({
            label: e,
            options: o.sort((s, c) => s.label.localeCompare(c.label))
          }));
        }
        case l.RADIO:
          return d.map((t) => ({
            label: t.text,
            value: t.id,
            [f]: t
          }));
        default:
          return;
      }
  }, [r, d]), N = p(() => {
    if (r != null && r.widget)
      switch (r.widget) {
        case l.CHECKBOX:
          return { children: r.label };
        default:
          return;
      }
  }, [r]), { validateStatus: O, helpMessage: S } = p(() => {
    let t, a;
    return E && E.statusCode === F.FORMS_GET_OPTIONS_NOT_FOUND_CATALOG_SCHEMA && (t = "error", a = u("field.errors.emptyListValues")), { validateStatus: t, helpMessage: a };
  }, [E, u]), P = C(() => {
    U.sendEvent(G.FormFieldFocused, {
      fieldId: m
    });
  }, [m]);
  if (!(r != null && r.type))
    return null;
  const R = l.CHECKBOX === r.widget ? "checked" : void 0, w = l.CHECKBOX !== r.widget ? r.label : void 0;
  return /* @__PURE__ */ g(
    x.Item,
    {
      name: m,
      label: w,
      loading: _,
      required: r.required,
      rules: A,
      dependencies: r.depends,
      valuePropName: R,
      validateStatus: O,
      help: S,
      children: /* @__PURE__ */ g(
        q,
        {
          ...N,
          widgetType: r.widget,
          disabled: h,
          loading: _,
          options: L,
          placeholder: r.placeholder ?? void 0,
          onFocus: P
        }
      )
    }
  );
});
export {
  $ as Field
};
